var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/_getPrototype.js
// module id = 233
// module chunks = 0